import { render } from "./Fourth.vue?vue&type=template&id=23ccb1ae&scoped=true"
import script from "./Fourth.vue?vue&type=script&lang=js"
export * from "./Fourth.vue?vue&type=script&lang=js"

import "./Fourth.vue?vue&type=style&index=0&id=23ccb1ae&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ccb1ae"]])

export default __exports__